import React, { useEffect, useState } from 'react';

import { IonContent, useIonViewWillEnter } from '@ionic/react';
// import { IonBackButton, IonButtons, IonButton } from '@ionic/react';
import { IonList, IonItem } from '@ionic/react';

// import { cartOutline as cart } from 'ionicons/icons';

// import Price from '../components/Price';
// import OptionService from '../services/option';
// import SearchService from '../services/product';
import AuthResource from '../resources/Auth';
import CartResource from '../resources/Cart';
import usePromotions from '../hooks/Promotions/usePromotions';
import useOptions from '../hooks/Shared/useOptions';
import OptionService from '../services/option';
import SkeletonPromotions from '../components/Promotions/SkeletonPromotions';
import Item from '../components/Promotions/Item';
import HeaderPromotions from '../components/Promotions/HeaderPromotions';
// import { IonSkeletonText } from '@ionic/react';

import { pricetagsOutline as promotions } from 'ionicons/icons';

const PromotionsPage = (props) => {
  const [promotions, promotionsLoading, promotionsError, loadPromotions] = usePromotions();
  const { toast } = props;
  const { history } = props;
  const [options, setOptions] = useState(null);

  const addProductToCart = async (prod, nome_prodotto = 'Prodotto') => {
    if (!(await AuthResource.isLogged)) {
      toast.current.add({
        message: `Accedi o registrati`,
        color: 'warning',
      });
      history.push('/auth/login');
      return;
    }

    await CartResource.addProduct(prod);
    toast.current.add({
      message: `${nome_prodotto} aggiunto al carrello`,
    });
  };

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await OptionService.allClean();
        const optionsData = response.data.data;
        setOptions(optionsData);
      } catch (error) {
        console.error('Errore durante il caricamento delle opzioni:', error);
      }
    };

    fetchOptions();
  }, []);

  useIonViewWillEnter(() => {
    loadPromotions();
  });

  return (
    <>
      <HeaderPromotions />
      <IonContent fullscreen>
        {options?.volantino ? (
          <iframe
            src={`https://docs.google.com/gview?url=https://api.farmaciademo.wayan.it/volantino/volantino&embedded=true`}
            style={{ width: '100%', height: '100vh', border: 'none' }}
            title="PDF Viewer"
          />
        ) : !promotionsLoading && !promotionsError && promotions && promotions.length > 0 ? (
          <IonList>
            {promotions.map((prod, key) => (
              <Item key={key} prod={prod} history={history} addProductToCart={addProductToCart} />
            ))}
          </IonList>
        ) : (
          <IonItem>Non ci sono promozioni disponibili</IonItem>
        )}
      </IonContent>
      {/* <IonContent>

        <IonList>
          {!promotionsLoading && !promotionsError ?
            <>
              {
                promotions?.map((prod, key) => (
                  <Item key={key} prod={prod} history={history} addProductToCart={addProductToCart} />
                ))
              }
            </>
            :
            <SkeletonPromotions />
          }
        </IonList>
      </IonContent> */}
    </>
  );
};

export default PromotionsPage;
